import { useEffect } from 'react'

interface MenuEntriesWrapperProps {
  children: JSX.Element[]
}

export const MenuEntriesWrapper = ({ children }: MenuEntriesWrapperProps) => {
  useEffect(() => {
    document.body.style.setProperty('overflow', 'hidden')

    return () => {
      if (document.body.style.overflow === 'hidden') {
        document.body.style.setProperty('overflow', 'auto')
      }
    }
  }, [])

  return children
}
